export enum PhApprovalSubFeatureEnum{
    PH_APPROVAL='PH_APPROVAL',
    BARCODE = 'BARCODE',
    RELEASE ='RELEASE',
}